module.exports = __webpack_public_path__ + "assets/novanaut--head.f41a8b20955609e499d14eb8a69c3fb6.svg";


//////////////////
// WEBPACK FOOTER
// ../static/images/novanaut--head.svg
// module id = 435
// module chunks = 0